import { Button, Icon } from '@mairistem/composants';

interface BoutonsValidationEncaissementProps {
  loading: boolean;
  /** Boutons en vert quand la saisie est cohérente. */
  positive: boolean;
  /** `'print'` pour imprimer le reçu, `'mail'` pour l'envoyer, rien pour valider sans reçu. */
  onValidate: (param?: 'print' | 'mail') => void;
  /** Bouton « Valider sans imprimer le reçu » : masqué en mode LOOC. */
  sansRecuVisible: boolean;
  sansRecuDisabled: boolean;
  /** `disabled` des deux boutons produisant un reçu (mail et impression). */
  avecRecuDisabled: boolean;
  /** Bouton d'envoi par mail : visible si la régie l'autorise. */
  mailVisible: boolean;
  /** Le bouton de retour n'est rendu que si une fermeture est possible (absent en LOOC). */
  onClose?: () => void;
  retourContent: string;
  testIds: { retour: string; sansRecu: string; mail: string; print: string };
}

/**
 * Boutons d'action d'une modale d'encaissement.
 *
 * À placer DANS un `Modal.Actions` de l'appelant : `Modal` de `@mairistem/composants`
 * identifie ses zones en inspectant le type de ses enfants directs, un composant
 * intermédiaire y serait traité comme du contenu.
 */
const BoutonsValidationEncaissement = ({
  loading,
  positive,
  onValidate,
  sansRecuVisible,
  sansRecuDisabled,
  avecRecuDisabled,
  mailVisible,
  onClose,
  retourContent,
  testIds,
}: BoutonsValidationEncaissementProps) => (
  <>
    {onClose && (
      <Button
        data-testid={testIds.retour}
        onClick={onClose}
        size="tiny"
        basic
        icon="close"
        content={retourContent}
        disabled={loading}
        loading={loading}
      />
    )}
    {sansRecuVisible && (
      <Button
        data-testid={testIds.sansRecu}
        content="Valider sans imprimer le reçu"
        disabled={sansRecuDisabled}
        onClick={() => {
          onValidate();
        }}
        positive={positive}
        icon="checkmark"
        loading={loading}
      />
    )}
    {mailVisible && (
      <Button
        data-testid={testIds.mail}
        disabled={avecRecuDisabled}
        loading={loading}
        onClick={() => {
          onValidate('mail');
        }}
        positive={positive}
      >
        <Icon.Group>
          <Icon name="mail" />
          <Icon name="checkmark" corner style={{ fontSize: '0.7em', top: 7, right: -1 }} />
        </Icon.Group>
        Valider et envoyer le reçu par mail
      </Button>
    )}
    <Button
      data-testid={testIds.print}
      disabled={avecRecuDisabled}
      loading={loading}
      onClick={() => {
        onValidate('print');
      }}
      positive={positive}
    >
      <Icon.Group>
        <Icon name="print" />
        <Icon name="checkmark" corner style={{ fontSize: '0.7em', top: 7, right: -1 }} />
      </Icon.Group>
      Valider et imprimer le reçu
    </Button>
  </>
);

export default BoutonsValidationEncaissement;
